module.exports = __webpack_public_path__ + "img/quadruped.3d4a17bb.png";